import PhoneNumberInput from "./PhoneNumberInput";
export default PhoneNumberInput;

export const UNMASKED_PHONE_NUMBER_LENGTH = 10;
export const MASKED_PHONE_NUMBER_LENGTH = UNMASKED_PHONE_NUMBER_LENGTH + 4;
